module.exports = __webpack_public_path__ + "img/1bilde_uzlabots.109cbc9c.jpg";